/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetNotificationDiscordStatus,
  FleetNotificationSetting,
  FleetNotificationSettingUpdateInput,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Show fleet notification settings
 */
export const fleetNotificationSetting = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetNotificationSetting>(
      {url: `/fleets/${fleetSlug}/notifications`, method: 'GET', signal
    },
      );
    }




export const getFleetNotificationSettingQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'notifications'
    ] as const;
    }


export const getFleetNotificationSettingQueryOptions = <TData = Awaited<ReturnType<typeof fleetNotificationSetting>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetNotificationSetting>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetNotificationSettingQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetNotificationSetting>>> = ({ signal }) => fleetNotificationSetting(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetNotificationSetting>>, TError, TData>
}

export type FleetNotificationSettingQueryResult = NonNullable<Awaited<ReturnType<typeof fleetNotificationSetting>>>
export type FleetNotificationSettingQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show fleet notification settings
 */

export function useFleetNotificationSetting<TData = Awaited<ReturnType<typeof fleetNotificationSetting>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetNotificationSetting>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetNotificationSettingQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update fleet notification settings
 */
export const updateFleetNotificationSetting = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetNotificationSettingUpdateInput: MaybeRefOrGetter<FleetNotificationSettingUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetNotificationSettingUpdateInput = toValue(fleetNotificationSettingUpdateInput);

      return axiosClient<FleetNotificationSetting>(
      {url: `/fleets/${fleetSlug}/notifications`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: fleetNotificationSettingUpdateInput, signal
    },
      );
    }




export const getUpdateFleetNotificationSettingMutationKey = () => ['updateFleetNotificationSetting'] as const;

export const getUpdateFleetNotificationSettingMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetNotificationSetting>>, TError,UpdateFleetNotificationSettingMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetNotificationSetting>>, TError,UpdateFleetNotificationSettingMutationVariables, TContext> => {

const mutationKey = getUpdateFleetNotificationSettingMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetNotificationSetting>>, UpdateFleetNotificationSettingMutationVariables> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  updateFleetNotificationSetting(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetNotificationSettingMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetNotificationSetting>>>
    export type UpdateFleetNotificationSettingMutationBody = FleetNotificationSettingUpdateInput
    export type UpdateFleetNotificationSettingMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateFleetNotificationSettingMutationVariables = {fleetSlug: string;data: FleetNotificationSettingUpdateInput}

    /**
 * @summary Update fleet notification settings
 */
export const useUpdateFleetNotificationSetting = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetNotificationSetting>>, TError,UpdateFleetNotificationSettingMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetNotificationSetting>>,
        TError,
        UpdateFleetNotificationSettingMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetNotificationSettingMutationOptions(options), queryClient);
    }
    /**
 * @summary Probe the fleet's Discord guild binding
 */
export const fleetNotificationDiscordStatus = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetNotificationDiscordStatus>(
      {url: `/fleets/${fleetSlug}/notifications/discord-status`, method: 'GET', signal
    },
      );
    }




export const getFleetNotificationDiscordStatusQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'notifications','discord-status'
    ] as const;
    }


export const getFleetNotificationDiscordStatusQueryOptions = <TData = Awaited<ReturnType<typeof fleetNotificationDiscordStatus>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetNotificationDiscordStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetNotificationDiscordStatusQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetNotificationDiscordStatus>>> = ({ signal }) => fleetNotificationDiscordStatus(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetNotificationDiscordStatus>>, TError, TData>
}

export type FleetNotificationDiscordStatusQueryResult = NonNullable<Awaited<ReturnType<typeof fleetNotificationDiscordStatus>>>
export type FleetNotificationDiscordStatusQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Probe the fleet's Discord guild binding
 */

export function useFleetNotificationDiscordStatus<TData = Awaited<ReturnType<typeof fleetNotificationDiscordStatus>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetNotificationDiscordStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetNotificationDiscordStatusQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






